/*
 * Small shared control for the auto-scrolling marquee sections
 * (Featured On, Reviews). Replaces the old CSS `:hover` pause --
 * which could get stuck "paused" on touch devices and offered no
 * way to resume on desktop without moving the cursor away -- with
 * an explicit play/pause button. Each marquee wrapper carries
 * [data-marquee]; its toggle button carries [data-marquee-toggle].
 */
(function () {
  function initMarqueeToggles() {
    document.querySelectorAll('[data-marquee-toggle]').forEach(function (button) {
      if (button.dataset.marqueeToggleBound) return;
      button.dataset.marqueeToggleBound = 'true';

      button.addEventListener('click', function () {
        var marquee = button.closest('[data-marquee]');
        if (!marquee) return;

        var paused = marquee.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarqueeToggles);
  } else {
    initMarqueeToggles();
  }

  // Re-bind after theme editor section re-renders.
  document.addEventListener('shopify:section:load', initMarqueeToggles);
})();
